import React, { useEffect, useRef } from 'react';
import { Sprout, Search, Shovel, CalendarDays, ShieldCheck, Tractor } from 'lucide-react';
import './ourprocess.css';

const OurProcess = () => {
  const stepsData = [
    {
      title: 'Consultation',
      description: 'Strategic planning and expert advice tailored specifically to your unique farming goals and land capabilities.',
      icon: <Sprout size={28} />
    },
    {
      title: 'Soil Identification',
      description: 'Scientific analysis of soil composition to determine the most viable and profitable crops for your specific terrain.',
      icon: <Search size={28} />
    },
    {
      title: 'Soil Prep & Planting',
      description: 'Comprehensive land preparation including tilling and enrichment, followed by precision planting for optimal growth.',
      icon: <Shovel size={28} />
    },
    {
      title: 'Maintenance Schedule',
      description: 'A detailed, calendar-based care plan covering irrigation, nutrition, and monitoring to ensure crop health.',
      icon: <CalendarDays size={28} />
    },
    {
      title: 'Production & Protection',
      description: 'Ongoing management of crop development with integrated pest management and protective farming practices.',
      icon: <ShieldCheck size={28} />
    },
    {
      title: 'Harvest',
      description: 'Timely harvesting at peak maturity to maximize yield quality, quantity, and market value.',
      icon: <Tractor size={28} />
    },
  ];

  // Ref for observer to trigger animations
  const timelineRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('op-visible');
          }
        });
      },
      { threshold: 0.2 }
    );

    const items = document.querySelectorAll('.op-timeline-content');
    items.forEach((item) => observer.observe(item));

    return () => {
      items.forEach((item) => observer.unobserve(item));
    };
  }, []);

  return (
    <div className="op-container">
      {/* Hero Section */}
      <section className="op-hero">
        <div className="op-hero-bg">
          <img
            src="https://res.cloudinary.com/drevfgyks/image/upload/v1725031277/AMARAVATHI%20NATURO%20TECH%20PVT%20LTD/One_Million_Trees_Day_gxtyef.png"
            alt="Farm Landscape"
          />
        </div>
        <div className="op-hero-overlay"></div>
        <div className="op-hero-content">
          <h1 className="op-hero-title">Our Process</h1>
          <p className="op-hero-subtitle">
            A systematic, science-backed journey from soil analysis to bountiful harvest, ensuring your agricultural success at every step.
          </p>
        </div>
      </section>

      {/* Timeline Section */}
      <section className="op-timeline-section" ref={timelineRef}>
        {stepsData.map((step, index) => (
          <div key={index} className="op-timeline-item">
            {/* Center Marker */}
            <div className="op-marker-container">
              <span className="op-marker-number">{index + 1}</span>
            </div>

            {/* Content Card */}
            <div className="op-timeline-content">
              <div className="op-step-header">
                <div className="op-step-icon">
                  {step.icon}
                </div>
                <h3 className="op-step-title">{step.title}</h3>
              </div>
              <p className="op-step-desc">{step.description}</p>
            </div>
          </div>
        ))}
      </section>

      <div className="op-tagline">
        Emerging Farmers Empowerment
      </div>
    </div>
  );
};

export default OurProcess;
